// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partnerSwitchModal .modal__content{max-width:394px}.partnerSwitchModal .modal__content .buttonContainer{display:flex;justify-content:flex-end}.partnerSwitchModal .modal__content .buttonContainer #partnerSwitchConfirm{margin-left:1em}", ""]);
// Exports
module.exports = exports;
